import { useEffect, useState } from "react";
import { fetchPayRolls, generateSelectedPayRolls, generatePayRolls, downloadPayrollData } from "../Api/ViewPayRoll";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";

const ViewPayRoll = () => {
  const [payRolls, setPayRolls] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [userName, setUserName] = useState(""); 

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUserName(storedUsername);
    }

    const loadPayRolls = async () => {
      try {
        const data = await fetchPayRolls();
        setPayRolls(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Pay Rolls`);
      }
    };

    loadPayRolls();
  }, []);

  const handleGenerate = async (payRoll) => {
    if (!userName) {
      toast.error("User information not available");
      return;
    }

    setIsGenerating(true);
    try {
      const response = await generatePayRolls(payRoll, userName);
      toast.success(`Successfully generated pay rolls`);
      console.log("Generation response:", response);
      
      setPayRolls(prevPayRolls => 
        prevPayRolls.filter(item => item.payrollId !== payRoll.payrollId)
      );
    } catch (error) {
      toast.error(`Error generating pay rolls: ${error.message}`);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleDownloadAll = async () => {
    if (payRolls.length === 0) {
      toast.warning("No payroll data available to download");
      return;
    }

    setIsDownloading(true);
    try {
      const payrollIds = payRolls.map(payRoll => payRoll.payrollId);
      const response = await downloadPayrollData(payrollIds);
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'payroll_data.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success("Payroll data downloaded successfully");
    } catch (error) {
      toast.error(`Error downloading payroll data: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="list-title">View Pay Rolls</span>
              <Button className="generate-btn"
                variant="success" 
                onClick={handleDownloadAll}
                disabled={isDownloading || payRolls.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Payroll Data'}
              </Button>
            </div>

            {payRolls.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table custom-sticky-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Pay Roll ID</th>
                        <th>Employee Name</th>
                        <th>Working Days ID</th>
                        <th>Resource ID</th>
                        <th>Calendar Days</th>
                        <th>Salary Days</th>
                        <th>Doc No</th>
                        <th>Doc Fy</th>
                        <th>Doc CC</th>
                        <th>Gross</th>
                        <th>PF</th>
                        <th>ESIC</th>
                        <th>Deduction</th>
                        <th>Asset</th>
                        <th>Advance</th>
                        <th>Loan</th>
                        <th>Leave</th>
                        <th>Net Payable</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {payRolls.map((payRoll, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{payRoll.payrollId}</td>
                          <td>{payRoll.name}</td>
                          <td>{payRoll.workingDaysId}</td>
                          <td>{payRoll.resourceid}</td>
                          <td>{payRoll.calendarDays}</td>
                          <td>{payRoll.salaryDays}</td>
                          <td>{payRoll.docNo}</td>
                          <td>{payRoll.docFy}</td>
                          <td>{payRoll.docCc}</td>
                          <td>{payRoll.gross}</td>
                          <td>{payRoll.pf}</td>
                          <td>{payRoll.esic}</td>
                          <td>{payRoll.tdsdeductionAmount}</td>
                          <td>{payRoll.asset}</td>
                          <td>{payRoll.advance}</td>
                          <td>{payRoll.loan}</td>
                          <td>{payRoll.leave}</td>
                          <td>{payRoll.netPayable}</td>
                          <td>
                            <Button 
                              variant="primary" 
                              onClick={() => handleGenerate(payRoll)}
                              className="generate-btn"
                              disabled={isGenerating}
                              size="sm"
                            >
                              Generate
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No pay rolls found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewPayRoll;